import { getAllPresse } from "../../../../API/Presse/presseService";
import { PresseData } from "./../../../../components/tables/presse-tables/presse";
import { useEffect, useState } from "react";
import BreadCrumb from "../../../../components/breadcrumb";
import Header from "../../../../components/DashboardNavigation/header";
import Sidebar from "../../../../components/DashboardNavigation/sidebar";

const breadcrumbItems = [{ title: "Presse", link: "/admin-dashboard/presse" }];
export default function Presse() {
  const [presse, setPresses] = useState<any[]>([]);
  const fetchData = async () => {
    const response = await getAllPresse();
    setPresses(response?.presse);
  };
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <Header />
      <div className="flex h-screen overflow-hidden">
        <Sidebar />
        <div className="flex-1 p-4 pt-6 space-y-4 md:p-8">
          <BreadCrumb items={breadcrumbItems} />
          <PresseData data={presse} />
        </div>
      </div>
    </>
  );
}
